module.exports = __webpack_public_path__ + "static/img/hdw5.0d4994d5.jpg";